import "../../lodging/lodging-details/lodging-details.css";
import "../../golf/golf-details/golf-details.css";
import "../../VendorDetails.css"

import React, { useContext, useEffect, useState } from "react";
import { Form, Row, Col, Tab, Nav, Carousel, Button, Modal, Spinner } from "react-bootstrap";
import DayPickerInput from "react-day-picker/DayPickerInput";
import reactMoment from "react-day-picker/moment";
import { Modifier } from "react-day-picker";
import Amenity from "../../../../../../../Data/Amenity";
import GolfItem from "../../../../../../../Data/GolfItem";
import VendorUnit from "../../../../../../../Data/VendorUnit";
import VendorUnitImage from "../../../../../../../Data/VendorUnitImage";
import WidgetStyle from "../../../../../../../Data/WidgetStyle";
import { DatesAndGuests } from "../../../../widget-form/WidgetForm";
import StartWidget from "../../../../../../../Data/StartWidget";
import RatesByDate from "../../../../../../../Data/Rates/DateRate";
import UnitRate from "../../../../../../../Data/Rates/UnitRate";
import ProductRate from "../../../../../../../Data/Rates/ProductRate";
import { WidgetContext } from "../../../../../../../context/WidgetContext";
import { MobileDayPickerOverlay } from "../../../../assets/MobileDayPickerOverlay";
import moment from "moment";
import VendorDescriptionImage from "../../../../../../../Data/VendorDescriptionImage";
import Decimal from "decimal.js";
import { getAvailableVendorUnits, getVendorUnitIdFromUnitName, getVendorUnitIdsFromSelectedName } from "../../../../../../../Data/Rates/UnitRateLogic";
import { roundDecimal, isStringEmpty } from "../../../../../../../_helpers/Functions";
import { toast, useToast } from "react-toastify";
import CustomDayPickerInput from "../../../../../customDayPickerInput/CustomDayPickerInput";
import UseGetGolfVendors, { GetGolfVendorsRequest } from "../add-golf/data-service-hooks/UseGetGolfVendors";
import { TimeOption } from "../../../../../../../_helpers/Types";
// import SameDayReplay from "../../../../../../../Data/SameDayReplay";

interface props {
  vendor: GolfItem;
  datesAndGuests: DatesAndGuests;
  onSelectedVendorUnit?: (item: GolfItem, index?: number) => void;
}

interface GeoProps {
  lat: number;
  lng: number;
}

const GolfDetails: React.FC<props> = (props) => {
  const { startWidget, style, viewPortBreakPoint, autoScroll, /* brandId */brand } = useContext(WidgetContext);

  const { datesAndGuests, onSelectedVendorUnit } = props;
  const [vendor, setVendor] = useState(props.vendor);
  const isEditing = vendor.itineraryIndex !== undefined && vendor.itineraryIndex > -1;

  const [players, setPlayers] = useState(isEditing ? vendor.numberOfGuests : datesAndGuests.guests);
  const [playDate, setPlayDate] = useState<string>(!isStringEmpty(vendor.startDate) ? vendor.startDate : datesAndGuests.fromDate.toDateString());
  const [showReplayModal, setShowReplayModal] = useState(false);
  const { formatDate, parseDate } = reactMoment;
  const [latlang, setLatLang] = useState<GeoProps>();
  const [geoLocation, setGeoLocation] = useState("");
  // const [unitId, setUnitId] = useState(vendor.vendorUnits.length > 0 ? vendor.vendorUnits[0].vendorUnitId : undefined);

  const maxGuests = datesAndGuests.guests;
  const scorecardImg = vendor.description && vendor.description.vendorDescriptionImages ? vendor.description.vendorDescriptionImages.find((img: VendorDescriptionImage) => img.imageType === 1) : undefined;

  const [selectedUnit, setSelectedUnit] = useState<number | null>(null);
  const [selectedProductRate, setSelectedProductRate] = useState<ProductRate | null>(null);
  const [selectedTeeTime, setSelectedTeeTime] = useState<string | null>(null);
  const [productRate, setProductRate] = useState<ProductRate>();

  const [teeTimes, setTeeTimes] = useState<TimeOption[]>([]);
  const [ratesForPlayDate, setRatesForPlayDate] = useState<UnitRate[]>([]);
  const [unavailableMessage, setUnavailableMessage] = useState<string>('');
  const [ratesForUnit, setRatesForUnit] = useState<ProductRate[]>([]);
  const [teeTimeRate, setTeeTimeRate] = useState<Decimal | undefined>();
  const [vendorUnits, setVendorUnits] = useState<VendorUnit[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [getGolfVendorsRequest, setGetGolfVendorsRequest] = useState<GetGolfVendorsRequest>();
  const responseGetGolfVendors = UseGetGolfVendors(getGolfVendorsRequest);

  const rates = vendor && vendor.dailyRates ? vendor.dailyRates : [];
  const [selectedUnitName, setSelectedUnitName] = useState<string | null>(null);
  // const [vendorUnitIds, setVendorUnitIds] = useState<Number[]>([]);

  const [imgErrors, setImgErrors] = useState<number[]>([]);
  const placeholderImgUrl = "https://images.unsplash.com/photo-1566073771259-6a8506099945?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80";

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex: any, e: any) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    setVendor(props.vendor);
  }, [props.vendor]);

  const onGuestsInputChanged = (event: any) => {
    setPlayers(+event.target.value);
  };

  const teeTimesOptions = teeTimes.map((teeTime: TimeOption, index: number) => (
    <option value={teeTime.value} key={index}>{`${(viewPortBreakPoint <= 768 ? "Time: " : "")}`}{teeTime.label}</option>
  ));

  const unitOptions = vendorUnits.filter(u => u.published).map((unit: VendorUnit, index: number) => (
    <option value={unit.uniqueIdForSelection} key={index}>{unit.unitName}</option>
  ));

  const playerOptions = Array.from({
    length: Math.min(productRate !== undefined && productRate.isLive ?
      // Math.min(productRate.openSpots, 4) : players, players)
      Math.min(players, players) : players, players)
  }, (_, i) => i + 1).map((number: number, index: number) => (
    <option value={number} key={index}>{number}</option>
  ));

  function addClick(golf: VendorUnit) {
    if (productRate !== undefined && productRate.isLive) {
      let playerCount = players;
      let startingIndex = teeTimes.findIndex(t => t.foreUpTeeTimeId === productRate.foreUpTeeTimeId || t.golfNowTeeTimeId === productRate.golfNowTeeTimeId || t.lightSpeedTeeTimeId === productRate.lightSpeedTeeTimeId);

      do {
        playerCount -= teeTimes[startingIndex++].openSpots;
      } while (playerCount > 0 && startingIndex < teeTimes.length);

      if (playerCount > 0) {
        toast.error(`Not enough remaining Tee Times to fulfill remaining ${playerCount} player${(playerCount > 1 ? "s" : "")}`);
        return;
      }
    }

    golf.vendorId = vendor.vendorId;

    golf.sell = unitRate();

    vendor.selectedUnit = golf;
    vendor.startDate = playDate;
    vendor.endDate = playDate;
    vendor.startTime = selectedTeeTime as string;
    vendor.endTime = selectedTeeTime as string;
    vendor.numberOfGuests = players;
    vendor.numberOfUnits = players;

    vendor.productRateId = productRate !== undefined ? productRate.productRateId : 0;
    vendor.foreUpTeeTimeId = productRate !== undefined ? productRate.foreUpTeeTimeId : "";
    vendor.golfNowTeeTimeId = productRate !== undefined ? productRate.golfNowTeeTimeId : "";
    vendor.lightSpeedTeeTimeId = productRate !== undefined ? productRate.lightSpeedTeeTimeId : "";
    vendor.availableTimes = teeTimes;

    if (onSelectedVendorUnit)
      onSelectedVendorUnit(vendor, vendor.itineraryIndex);
    // //push new array into golf replays
    // vendor.sameDayReplays.push([]);
  }

  function populateTeeTimes() {
    const selectedPlayDate = moment(playDate).format('YYYY-MM-DD');
    const ratesForDate = rates.find(rate => selectedPlayDate.toString() === moment(rate.date).format('YYYY-MM-DD').toString());

    if (ratesForDate) {
      const selectedRates = ratesForDate.unitRates.filter(a => a.vendorUnitDisplayName === selectedUnitName);
      const ratesForUnit = selectedRates.flatMap(a => a.rates);
      // Set the tee times.
      let rateTeeTimes: TimeOption[] = [];
      ratesForUnit.forEach(r => {
        let start = moment(r.startTime, 'HH:mm');
        let end = moment(r.endTime, 'HH:mm');
        if (r.startTime !== r.endTime)
          start.minutes(Math.ceil(start.minutes() / 10) * 10);
        let result: TimeOption[] = [];
        let current = moment(start);
        while (current <= end) {
          result.push({
            value: current.format('HH:mm'),
            label: current.format('hh:mm a') + (r.isLive ? ` (${r.openSpots} players)` : ""),
            foreUpTeeTimeId: r.isLive ? r.foreUpTeeTimeId : "",
            golfNowTeeTimeId: r.isLive ? r.golfNowTeeTimeId : "",
            lightSpeedTeeTimeId: r.isLive ? r.lightSpeedTeeTimeId : "",
            openSpots: r.openSpots,
            price: r.price,
            isLive: r.isLive,
            vendorUnitId: r.vendorUnitId,
            productRateId: r.productRateId
          });
          current.add(10, 'minutes');
        }
        rateTeeTimes = rateTeeTimes.concat(result);
      });
      if (!!rateTeeTimes.length) {
        rateTeeTimes = [...new Map(rateTeeTimes.map(item => [item.value, item])).values()] // Remove any cross-over duplicates.
      }
      rateTeeTimes.sort((a, b) => {
        // Sort by time.
        return moment(a.value, 'HH:mm').isBefore(moment(b.value, 'HH:mm')) ? -1 : 0;
      });

      if (!!rateTeeTimes.length) {
        setSelectedTeeTime(isEditing ? vendor.startTime : rateTeeTimes[0].value);
        setUnavailableMessage('');
      }
      setTeeTimes(rateTeeTimes);

      if (ratesForDate.unavailable) {
        setUnavailableMessage(ratesForDate.unavailableMessage || "Unavailable");
      } else if (selectedRates.some(r => r.unavailable)) {
        setUnavailableMessage(selectedRates[0].unavailableMessage);
      } else if (rateTeeTimes.length === 0) {
        setUnavailableMessage("No rates available for this date");
      }
    }
  }

  function unitRate(): number {
    if (!teeTimeRate) {
      return 0;
    }

    return roundDecimal(teeTimeRate.times(players)).toNumber();
  }

  useEffect(() => {
    // map
    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${vendor.streetAddress},+${vendor.city},+${vendor.state}&key=AIzaSyAJ1DlLWQ9UpZ_46ufaWXdTzb6epSr87sU`
    ).then((response) => {
      return response.json();
    }).then((response) => {
      setLatLang({ lat: response.results[0].geometry.location.lat, lng: response.results[0].geometry.location.lng });
    });
  }, []);

  useEffect(() => {
    if (latlang) {

      const geolocationString = `https://www.google.com/maps/embed/v1/view?key=AIzaSyAJ1DlLWQ9UpZ_46ufaWXdTzb6epSr87sU
        &center=${latlang.lat},${latlang.lng}
        &zoom=15
        &maptype=roadmap`;

      setGeoLocation(geolocationString);
    }
  }, [latlang]);

  useEffect(() => {
    if (!vendor || isLoading) return;

    const _vendorUnits = getAvailableVendorUnits(vendor.vendorUnits, rates, moment(playDate).format("MM/DD/YYYY"));
    _vendorUnits.sort((a, b) => {
      if (a.sortOrder < b.sortOrder) return -1;
      if (a.sortOrder > b.sortOrder) return 1;

      if (a.unitName.toLowerCase() < b.unitName.toLowerCase()) return -1;
      if (a.unitName.toLowerCase() > b.unitName.toLowerCase()) return 1;

      return 0;
    });
    setVendorUnits(_vendorUnits);

    if (_vendorUnits.findIndex(a => a.uniqueIdForSelection == selectedUnitName) < 0) {
      if (_vendorUnits.length > 0) {
        setSelectedUnitName(_vendorUnits[0].uniqueIdForSelection);
        // setSelectedUnit(_vendorUnits[0].vendorUnitId);
      }
    }

    setUnavailableMessage("");
    populateTeeTimes();

    const ids = getVendorUnitIdsFromSelectedName(rates, selectedUnitName, moment(playDate).format("MM/DD/YYYY"));
    // setVendorUnitIds(ids);
  }, [vendor, playDate, isLoading]);

  useEffect(() => {
    if (isLoading) return;

    populateTeeTimes();
  }, [selectedUnitName, isLoading]);

  useEffect(() => {
    if (isLoading) return;

    const selectedPlayDate = moment(playDate).format('YYYY-MM-DD');
    const ratesForDate = rates.find(rate => selectedPlayDate.toString() === moment(rate.date).format('YYYY-MM-DD').toString());

    setRatesForPlayDate([]);

    if (!selectedTeeTime || !ratesForDate) {
      setTeeTimeRate(undefined);
      setProductRate(undefined);
      return;
    }

    if (ratesForDate.unavailable || ratesForDate.unitRates.length == 0) {
      var message = ratesForDate.unavailable ? ratesForDate.unavailableMessage as string : "No rates available for the play date.";
      setUnavailableMessage(message)
      // setTeeTimeRate(new Decimal(0));

      // return;

      if (ratesForDate.unitRates.length == 0) {
        setRatesForPlayDate([]);
        setTeeTimeRate(new Decimal(0));
        // setTeeTimeRate(undefined);
        return;
      }
    }

    setRatesForPlayDate(ratesForDate.unitRates);

    const ratesForUnit = ratesForDate.unitRates.flatMap(a => a.rates);
    setRatesForUnit(ratesForUnit);

    // const unitId = getVendorUnitIdFromUnitName([ratesForDate], selectedUnitName);
    const unitIds = getVendorUnitIdsFromSelectedName(rates, selectedUnitName, moment(playDate).format("MM/DD/YYYY"));
    const teeTimeRate = ratesForUnit.find(r => moment(r.startTime, "HH:mm").isSameOrBefore(moment(selectedTeeTime, "HH:mm")) && moment(r.endTime, "HH:mm").isSameOrAfter(moment(selectedTeeTime, "HH:mm")) && unitIds.includes(r.vendorUnitId));

    if (teeTimeRate) {
      setSelectedUnit(teeTimeRate ? teeTimeRate.vendorUnitId : null);
      setSelectedProductRate(teeTimeRate);
    }

    let rate = new Decimal(teeTimeRate ? teeTimeRate.price : 0);

    setTeeTimeRate(rate);
    setProductRate(teeTimeRate);
    // setVendorUnitIds(unitIds);
  }, [selectedTeeTime, selectedUnitName, playDate, isLoading]);

  useEffect(() => {
    setIndex(0);
  }, [selectedUnit]);

  useEffect(() => {
    if (brand === undefined) return;

    setGetGolfVendorsRequest({ brandId: brand?.brandId as number, startDate: moment(datesAndGuests.fromDate).format('YYYY-MM-DD'), endDate: moment(datesAndGuests.toDate).format('YYYY-MM-DD'), vendorId: vendor.vendorId });
  }, [props.vendor]);

  useEffect(() => {
    if (responseGetGolfVendors.data) {
      const responseData = responseGetGolfVendors.data;

      if (responseData.length > 0) {
        responseData[0].itineraryIndex = vendor.itineraryIndex;
        setVendor(responseData[0]);
      }
      setIsLoading(false);
    }
  }, [responseGetGolfVendors.data]);

  const inputStyle = `
  .inline-style .DayPickerInput>input {
    padding-left: 15px;
}`;

  const navLinkStyles = `
  .nav-pills .nav-link.active {
    background-color: rgb(247, 247, 247);
    color: ${style.buttonColor} !important;
}`;

  return (
    <React.Fragment>
      <style>{inputStyle}</style>
      <style>{navLinkStyles}</style>

      {/* Desktop */}
      <div className="d-none d-lg-block widget-font">
        {/* Dates */}
        <Row>
          <Col md={8}>
            <Row className="d-flex flex-row">
              <div className="d-flex flex-column inline-style">
                <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                  Date of Play
                </Form.Label>
                <CustomDayPickerInput
                  inputProps={{ style: { color: style.fontColor } }}
                  value={moment(playDate).format("ddd, MMM Do, YYYY")}
                  placeholder="Play Date"
                  format="LL"
                  formatDate={formatDate}
                  parseDate={parseDate}
                  dayPickerProps={{
                    selectedDays: [!isStringEmpty(playDate) ? moment(playDate).toDate() : datesAndGuests.fromDate],
                    disabledDays: { before: datesAndGuests.fromDate, after: datesAndGuests.toDate },
                    month: datesAndGuests.fromDate,
                    numberOfMonths: 1,
                  }}
                  onDayChange={(date: Date) => {
                    setPlayDate(date.toDateString());
                  }}
                />
              </div>

              <div className="d-flex flex-column pl-3">
                <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                  Players
                </Form.Label>
                <Form.Control
                  style={{ color: style.fontColor }}
                  as="select"
                  name="players"
                  className="guest-select"
                  onChange={onGuestsInputChanged}
                  defaultValue={players.toString()}
                >
                  {/* {getNumGuestsOptions()} */}
                  {playerOptions}
                </Form.Control>
              </div>

              {!isLoading && teeTimesOptions.length > 0 && (
                <div className="d-flex flex-column pl-3">
                  <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                    Tee Times
                  </Form.Label>
                  <Form.Control style={{ color: style.fontColor }} as="select" name="teeTime" value={selectedTeeTime || undefined} className="time-select p-1"
                    onChange={(event: any) => setSelectedTeeTime(event.currentTarget.value)}>
                    {teeTimesOptions}
                  </Form.Control>
                </div>
              )}

            </Row>
            <Row>
              {/* {unavailableMessage === "" && ( */}
              {!isLoading && teeTimesOptions.length > 0 && (
                <div className="w-100 d-flex flex-column" style={{ marginTop: "10px" }}>
                  <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                    Unit Type
                </Form.Label>
                  <Form.Control as="select"
                    style={{ color: style.fontColor }}
                    name="vendorUnit"
                    value={selectedUnitName || undefined}
                    onChange={(event: any) => {
                      setSelectedUnitName(event.currentTarget.value)
                    }} >
                    <option value="" hidden>Select a unit</option>
                    {unitOptions}
                  </Form.Control>
                </div>
              )}

              {isLoading && (
                <span className="mt-2"><Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                /> Loading...</span>
              )}

              {/* )} */}

              {/* {!!vendor.vendorUnits.find(unit => unit.vendorUnitId === selectedProductRate?.vendorUnitId) && (
                <Row className="m-0 p-0 my-2">
                  <p className="m-0 p-0">{vendor.vendorUnits.find(unit => unit.vendorUnitId === selectedProductRate?.vendorUnitId)?.unitDescription}</p>
                </Row>
              )} */}

              {vendor.vendorUnits.find(unit => unit.vendorUnitId === selectedUnit)?.unitDescription && (
                <Row className="m-0 p-0 my-2">
                  <p className="m-0 p-0">{vendor.vendorUnits.find(unit => unit.vendorUnitId === selectedUnit)?.unitDescription}</p>
                </Row>
              )}

              {!isStringEmpty(unavailableMessage) && (
                <Row className="m-0 p-0 my-2">
                  <p className="m-0 p-0 font-italic text-danger">{unavailableMessage}</p>
                </Row>
              )}
            </Row>
          </Col>

          {!isLoading && (
            <Col md={4} className="pl-2 pb-1 d-flex flex-row justify-content-end align-items-end">
              {!!!unavailableMessage && teeTimesOptions.length > 0 && (<>
                {(selectedProductRate !== null && selectedProductRate.displayVendorPriceOverride && teeTimeRate !== undefined) || !vendor.rateDisplayOption.showPkgPriceOnly && startWidget.showLodgingPricing && teeTimeRate !== undefined ? (
                  <div className="add-buttons mr-3">
                    <p className="m-0 p-0 pr-3 font-weight-bold green-text">${teeTimeRate.toFixed(2)}</p>
                  </div>
                ) : (<>
                  <div className="add-buttons mr-3">
                    <p className="m-0 p-0 pr-3 font-weight-bold green-text">Package Price</p>
                  </div>
                </>)}
                <div className="add-buttons">
                  <Button
                    style={{ backgroundColor: style.buttonColor }}
                    className="lodging-detail-button add-button box-shadow"
                    onClick={() => {
                      // const _unitId = getVendorUnitIdFromUnitName(vendor.rates, selectedUnitName);
                      // if (_unitId)
                      //   addClick(vendor.vendorUnits.find(unit => unit.vendorUnitId == _unitId) as VendorUnit);
                      const vu = vendor.vendorUnits.find(unit => unit.vendorUnitId == selectedUnit) as VendorUnit;
                      addClick(vu);
                    }}
                  >
                    Add
                </Button>
                </div>
              </>)}
            </Col>
          )}
        </Row>

        {!isLoading && (
          <Tab.Container id="left-tabs-example" defaultActiveKey="photos">
            <Row className="widget-font">
              <Col xs={12} className="mobile-details-nav">
                <Nav variant="pills">
                  <Nav.Item>
                    <Nav.Link eventKey="photos" style={{ color: style.linkColor }}>Photos</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="about" style={{ color: style.linkColor }}>About</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="scorecard" style={{ color: style.linkColor }}>Scorecard</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="amenities" style={{ color: style.linkColor }}>Amenities</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="map" style={{ color: style.linkColor }}>Map</Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
              <Col
                xs={12}
                className="details-tab-content"
                style={{
                  backgroundColor: "rgb(222, 222, 222)",
                  marginTop: "0px",
                }}
              >
                <Tab.Content style={{ backgroundColor: "rgb(222, 222, 222)" }}>
                  {/* Photos */}
                  <Tab.Pane eventKey="photos">
                    <Carousel activeIndex={index} onSelect={handleSelect} indicators={false}
                      style={{
                        backgroundColor: "#F7F7F7",
                      }}
                    >
                      {vendor.vendorUnits && vendor.vendorUnits.some(u => u.vendorUnitId === selectedUnit && u.vendorUnitImages.length > 0) &&
                        vendor.vendorUnits.filter(u => u.vendorUnitId === selectedUnit).map((unit: VendorUnit) => {
                          return unit.vendorUnitImages.map((image: VendorUnitImage, index: number) => {
                            return (<Carousel.Item
                              key={`${unit.unitName}-${unit.vendorUnitId}-${index}`}
                              style={{
                                height: "auto",
                                backgroundColor: "#F7F7F7",
                              }}
                            >
                              <img
                                className="d-block w-100"
                                src={image.imageUrl}
                                alt={image.name}
                              />
                              <Carousel.Caption>
                                <p>{image.description}</p>
                              </Carousel.Caption>
                            </Carousel.Item>
                            )
                          })
                        })
                      }

                      {vendor.vendorUnits && !vendor.vendorUnits.some(u => u.vendorUnitId === selectedUnit && u.vendorUnitImages.length > 0) && (
                        <img
                          className="d-block w-100"
                          style={{
                            height: "500px",
                            backgroundColor: "#F7F7F7",
                          }}
                          src={vendor.description != undefined && vendor.description.vendorDescriptionImages.length > 0 ? vendor.description.vendorDescriptionImages[0].vendorImageUrl as string : ""}
                          alt={""}
                        />
                      )}
                    </Carousel>
                  </Tab.Pane>
                  <Tab.Pane className="p-3" eventKey="about" style={{ height: "auto" }}>
                    <p style={{ color: style.fontColor }}>{vendor.description ? vendor.description.description : ""}</p>
                  </Tab.Pane>
                  <Tab.Pane
                    eventKey="scorecard"
                    style={{
                      backgroundColor: "rgb(222, 222, 222)",
                      height: "auto",
                    }}
                  >
                    <a href={scorecardImg ? scorecardImg.vendorImageUrl : ""} target="_blank">
                      <img
                        className="scorecard"
                        style={{ objectFit: "contain" }}
                        src={scorecardImg ? scorecardImg.vendorImageUrl : ""}
                        alt={"scorecard"}
                      // onError={() => { imgErrors.push(index); setImgErrors([...imgErrors]); }}
                      />
                    </a>
                  </Tab.Pane>
                  <Tab.Pane
                    className="p-3"
                    eventKey="amenities"
                    style={{
                      backgroundColor: "rgb(222, 222, 222)",
                      height: "auto",
                    }}
                  >
                    {vendor.amenities.map((item: Amenity) => (
                      <p key={item.amenityName} style={{ backgroundColor: "rgb(222, 222, 222)", color: style.fontColor }}>
                        {item.amenityName}
                      </p>
                    ))}
                  </Tab.Pane>
                  <Tab.Pane eventKey="map" style={{ height: "auto" }}>
                    <div
                      className="d-flex flex-column align-items-center"
                    >
                      <iframe
                        className="map"
                        title="map"
                        // height="400px"
                        // width="700px"
                        // disableDefaultUI="true"
                        src={geoLocation}
                      ></iframe>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        )}

      </div>

      {/* Mobile */}
      {!isLoading && (
        <div className="d-lg-none">
          <Col className="d-flex flex-column align-items-center mobile-widget d-lg-none">
            <Col className="justify-content-center">
              {/* Room Type Select */}
              <div
                className="d-flex flex-row justify-content-between"
              >
                {/* <Form.Label className="mb-0 mt-2 mr-3">
                Type:
              </Form.Label> */}

                {vendorUnits.length > 0 && (
                  <Form.Control as="select" className="p-2"
                    style={{ color: style.fontColor }}
                    name="vendorUnit"
                    value={selectedUnitName || undefined}
                    onChange={(event: any) => {
                      setSelectedUnitName(event.currentTarget.value)
                    }} >
                    <option value="" hidden>Select a unit</option>
                    {unitOptions}
                  </Form.Control>
                )}
              </div>

              {/* Arrive DatePicker */}
              <div className="mobile InputFromTo " style={{ marginRight: "0px" }}>
                <Row className="mt-3">
                  <CustomDayPickerInput
                    overlayComponent={MobileDayPickerOverlay}
                    inputProps={{ readOnly: true, style: { color: style.fontColor } }}
                    value={`Play Date: ${moment(playDate).format("ddd, MMM Do, YYYY")}`}
                    placeholder="Play Date"
                    format="LL"
                    formatDate={formatDate}
                    parseDate={parseDate}
                    dayPickerProps={{
                      selectedDays: [playDate ? playDate : datesAndGuests.fromDate],
                      disabledDays: { before: datesAndGuests.fromDate as Date, after: datesAndGuests.toDate },
                      numberOfMonths: 1,
                      month: datesAndGuests.fromDate,
                      modifiers: { start: playDate ? playDate : datesAndGuests.fromDate, end: playDate ? playDate : datesAndGuests.fromDate }
                    }}
                    onDayChange={(date: Date) => {
                      setPlayDate(date.toDateString());
                    }}
                  />
                </Row>
              </div>

              {/* Guests / Tee Times */}
              {/* <div className="d-flex flex-row justify-content-between mt-3"> */}
              <Row className="w-100 mt-3">
                {/* Tee Times */}
                {teeTimesOptions.length > 0 && (
                  <div className="d-flex flex-row">
                    {/* <Form.Label style={{ marginTop: "8px", marginRight: "0px", color: style.fontColor }} className="mr-1">
                      Time:
                  </Form.Label> */}
                    <Form.Control
                      style={{ color: style.fontColor }}
                      as="select" name="teeTime" value={selectedTeeTime || undefined}
                      className="time-select p-2"
                      onChange={(event: any) => setSelectedTeeTime(event.currentTarget.value)}>
                      {teeTimesOptions}
                    </Form.Control>
                  </div>
                )}
              </Row>
              {/* </div> */}

              <Row>
                {/* Guests */}
                <div
                  className="d-flex flex-row"
                  style={{ marginTop: window.innerWidth > 394 ? 0 : "12px" }}
                // style={{marginTop: "8px"}}
                >
                  <Form.Label
                    style={{
                      color: style.fontColor,
                      paddingRight: "5px",
                      marginBottom: "0px",
                      marginTop: "8px",
                      marginLeft: "8px",
                    }}
                  >
                    Players:
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="guests"
                    className="guest-select"
                    style={{ color: style.fontColor }}
                    defaultValue={players.toString()}
                    onChange={onGuestsInputChanged}
                  >
                    {/* {getNumGuestsOptions()} */}
                    {playerOptions}
                  </Form.Control>
                </div>
              </Row>

              <div
                className="d-flex flex-row justify-content-end"
                style={{ paddingTop: "10px" }}
              >
                {false && (
                  <Button className="same-day-replay-button" style={{ padding: 0, margin: 0, color: style.buttonColor }}>
                    + Add Same Day Replay
                  </Button>
                )}
              </div>

              {vendorUnits.find(unit => unit.vendorUnitId === selectedUnit)?.unitDescription && (
                <Row className="m-0 p-0 my-2">
                  <p className="m-0 p-0">{vendorUnits.find(unit => unit.vendorUnitId === selectedUnit)?.unitDescription}</p>
                </Row>
              )}

              {/* Package Price */}
              {!!!unavailableMessage && (
                <div className="w-100 d-flex flx-row justify-content-between mt-3">
                  {(selectedProductRate !== null && selectedProductRate.displayVendorPriceOverride && teeTimeRate !== undefined) || !vendor.rateDisplayOption.showPkgPriceOnly && startWidget.showGolfPricing && teeTimeRate !== undefined ? (
                    <div className="pt-2">
                      <p className="m-0 p-0 pr-3 font-weight-bold green-text" style={{ fontSize: "18px" }}>${teeTimeRate.toFixed(2)}</p>
                    </div>
                  ) : (<>
                    <div className="add-buttons">
                      <p className="m-0 p-0 pr-3 font-weight-bold green-text">Package Price</p>
                    </div>
                  </>)}

                  <Button
                    type="submit"
                    className="mobile-add-button"
                    style={{
                      marginBottom: "2px",
                      marginTop: "3px",
                      backgroundColor: style.buttonColor
                    }}
                    onClick={() => {
                      // const _unitId = getVendorUnitIdFromUnitName(vendor.rates, selectedUnitName);
                      // if (_unitId)
                      //   addClick(vendor.vendorUnits.find(unit => unit.vendorUnitId == _unitId) as VendorUnit);
                      const vu = vendor.vendorUnits.find(unit => unit.vendorUnitId == selectedUnit) as VendorUnit;
                      addClick(vu);
                    }}
                  >
                    + {isEditing ? "Save" : "Add"}
                  </Button>
                </div>)}

              {unavailableMessage && (
                <Row className="m-0 p-0 my-2">
                  <p className="m-0 p-0 font-italic text-danger">{unavailableMessage}</p>
                </Row>
              )}

              {/* Navigation / Carousel / Tab Content */}
              <div className="d-flex flex-row justify-content-center">
                <Tab.Container
                  id="left-tabs-example"
                  defaultActiveKey="photos"
                // style={{ marginTop: "0px" }}
                >
                  <Row
                    className="w-100 justify-content-center widget-font"
                  >
                    <Col className="details-nav">
                      <Nav variant="pills" className="details-navbar">
                        <Nav.Item>
                          <Nav.Link
                            className="mobile-nav-links"
                            eventKey="photos"
                            style={{ color: style.linkColor }}
                          >
                            Photos
                        </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="mobile-nav-links"
                            eventKey="about"
                            style={{ color: style.linkColor }}
                          >
                            About
                        </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="mobile-nav-links"
                            eventKey="scorecard"
                            style={{ color: style.linkColor }}
                          >
                            Scorecard
                        </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="mobile-nav-links"
                            eventKey="amenities"
                            style={{ color: style.linkColor }}
                          >
                            Amenities
                        </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="mobile-nav-links"
                            eventKey="map"
                            style={{ color: style.linkColor }}
                          >
                            Map
                        </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col
                      xs={12}
                      className="details-tab-content"
                      style={{
                        marginTop: "0px",
                        backgroundColor: "rgb(222, 222, 222)",
                      }}
                    >
                      <Tab.Content
                        style={{
                          backgroundColor: "rgb(222, 222, 222)",
                          marginTop: "0px",
                        }}
                      >
                        {/* Photos */}
                        <Tab.Pane eventKey="photos">
                          <Carousel activeIndex={index} onSelect={handleSelect} indicators={false}
                            style={{
                              backgroundColor: "#F7F7F7",
                            }}
                          >
                            {/* Vendor Units has images now */}
                            {vendor.vendorUnits && vendor.vendorUnits.some(u => u.vendorUnitId === selectedUnit && u.vendorUnitImages.length > 0) &&
                              vendor.vendorUnits.filter(u => u.vendorUnitId === selectedUnit).map((unit: VendorUnit) => {
                                return unit.vendorUnitImages.map((image: VendorUnitImage, index: number) => {
                                  return (<Carousel.Item
                                    key={`${unit.unitName}-${unit.vendorUnitId}-${index}`}
                                    style={{
                                      height: "auto",
                                      backgroundColor: "#F7F7F7",
                                    }}
                                  >
                                    <img
                                      className="d-block w-100"
                                      src={image.imageUrl}
                                      alt={image.name}
                                    />
                                    <Carousel.Caption>
                                      <p>{image.description}</p>
                                    </Carousel.Caption>
                                  </Carousel.Item>
                                  )
                                })
                              })
                            }

                            {vendor.vendorUnits && !vendor.vendorUnits.some(u => u.vendorUnitId === selectedUnit && u.vendorUnitImages.length > 0) && (
                              <img
                                className="d-block w-100"
                                style={{
                                  height: "400px",
                                  backgroundColor: "#F7F7F7",
                                }}
                                src={vendor.description != undefined && vendor.description.vendorDescriptionImages.length > 0 ? vendor.description.vendorDescriptionImages[0].vendorImageUrl as string : ""}
                                alt={""}
                              />
                            )}
                          </Carousel>
                        </Tab.Pane>
                        <Tab.Pane
                          className="p-3"
                          eventKey="about"
                          style={{ height: "auto" }}
                        >
                          <p style={{ color: style.fontColor }}>{vendor.description ? vendor.description.description : ""}</p>
                        </Tab.Pane>
                        <Tab.Pane
                          eventKey="scorecard"
                          style={{ height: "auto" }}
                        >
                          <a href={scorecardImg ? scorecardImg.vendorImageUrl : ""} target="_blank">
                            <img
                              className="mobile-scorecard"
                              // style={{ objectFit: "contain" }} 
                              src={scorecardImg ? scorecardImg.vendorImageUrl : ""}
                              alt={"scorecard"}
                            // onError={() => { imgErrors.push(index); setImgErrors([...imgErrors]); }}
                            />
                          </a>
                        </Tab.Pane>
                        <Tab.Pane
                          className="p-3"
                          eventKey="amenities"
                          style={{
                            backgroundColor: "rgb(222, 222, 222)",
                            height: "auto",
                          }}
                        >
                          {vendor.amenities.map((item: Amenity) => (
                            <p key={item.amenityName} style={{ backgroundColor: "rgb(222, 222, 222)", color: style.fontColor }}>
                              {item.amenityName}
                            </p>
                          ))}
                        </Tab.Pane>
                        <Tab.Pane eventKey="map" >
                          <div
                            className="d-flex flex-column align-items-center"
                          >
                            <iframe
                              className="mobile-map"
                              title="map"
                              // disableDefaultUI="true"
                              src={geoLocation}
                            ></iframe>
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </div>
            </Col>
          </Col>
        </div>
      )}

      {isLoading && (
        <div className="d-lg-none">
          <span className="mt-2"><Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          /> Loading...</span>
        </div>
      )}


      {/* Same Day Replays Modal */}
      {/* <Modal
        show={false}
        size="lg"
        onHide={() => handleClose()}
      >
        <Modal.Header
          closeButton
          style={{
            border: "none",
            height: "100px",
            borderBottom: "1px solid rgb(222,222,222)",
          }}
        >
          <Modal.Title
            id="example-modal-sizes-title-lg"
            style={{ fontWeight: "bold" }}
          >
            {vendor.vendorName} Replay
              </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col>
            <label>Players</label>
            <Form.Control
              as="select"
              name="players"
              className="guest-select"
              style={{ width: "55px" }}
            >
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
            </Form.Control>
          </Col>

          <Col>
            <label>Tee Time</label>
            <Form.Control
              as="select"
              name="selectedUnit"
              className="guest-select"
              style={{ width: "80px" }}
            >
              <option>7:30 Am</option>
              <option>8:00 Am</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
            </Form.Control>
          </Col>
        </Modal.Body>
      </Modal> */}

    </React.Fragment>
  );
}

export default GolfDetails;